import { createApi } from '@reduxjs/toolkit/dist/query/react'
import baseQueryWithIam from '../../app/baseQueryWithIam'
import { CuratorState, LocationState } from '../types'

export const curatorProfileApiSlice = createApi({
    reducerPath: 'curatorProfileApi',
    baseQuery: baseQueryWithIam,
    tagTypes: ['Curator', 'Location'],
    endpoints: (build) => ({
        fetchCabinetData: build.query<CuratorState, void>({
            query: () => ({
                url: `curator/cabinet-data`,
            }),
            providesTags: (result) =>
                result
                    ? [
                        { type: 'Curator', id: 'LIST' },
                    ]
                    : [{ type: 'Curator', id: 'LIST' }],
            transformResponse: (response: any) => response.data,
        }),

        updateCuratorProfile: build.mutation<void, FormData>({
            query: (formData) => ({
                url: 'curator/cabinet-data',
                method: 'POST',
                body: formData,
            }),
            invalidatesTags: [{ type: 'Curator', id: 'LIST' }],
        }),

        fetchCuratorLocations: build.query<LocationState[], void>({
            query: () => ({
                url: 'curator/locations',
                method: 'GET',
            }),
            providesTags: (result) =>
                result
                    ? [
                        { type: 'Location', id: 'LIST' },
                    ]
                    : [{ type: 'Location', id: 'LIST' }],
            transformResponse: (response: any) => response.data,
        }),

        fetchCuratorData: build.query<CuratorState, void>({
            query: () => ({
                url: 'curator/data',
            }),
            providesTags: (result) =>
                result
                    ? [
                        { type: 'Curator', id: 'LIST' },
                    ]
                    : [{ type: 'Curator', id: 'LIST' }],
            transformResponse: (response: any) => response.data,
        }),
    }),
})
